<template>
  <section id="about" class="about-container">
    <h2>About Me</h2>
    <p class="intro-text">
      새로운 기술을 배우고 문제를 해결하는 과정에서 성취감을 느끼는 백엔드
      개발자입니다. <br />
      동료와 함께 성장하는 가치를 알며, 안정적인 서비스를 통해 비즈니스 가치를
      더하는 것을 목표로 합니다.
    </p>

    <div class="about-grid">
      <div class="about-card">
        <h3>Experience</h3>
        <ul>
          <li>
            <h4>KB IT's Your Life 5기 (2025)</h4>
            <p>
              현업 전문가 멘토링을 통해 금융 IT 서비스의 깊은 인사이트를 얻고
              실무 지식을 습득했습니다.
            </p>
          </li>
          <li>
            <h4>UMC 연합 개발 동아리 회장 (2023 - 2024)</h4>
            <p>
              50명 이상의 부원을 리드하며 스터디와 협업 프로젝트를 성공적으로
              기획 및 운영했습니다.
            </p>
          </li>
          <li>
            <h4>NEXON 서포터즈 해커톤 (2022)</h4>
            <p>
              빠른 프로토타이핑을 통해 아이디어를 현실로 만드는 실행력과 문제
              해결 능력을 길렀습니다.
            </p>
          </li>
        </ul>
      </div>

      <div class="about-card">
        <h3>Education</h3>
        <ul>
          <li>
            <h4>상명대학교 휴먼지능정보공학과 (2019 - 2025)</h4>
          </li>
        </ul>
        <h3 style="margin-top: 30px">Licenses</h3>
        <ul>
          <li>
            <h4>정보처리기사 (2024.12)</h4>
            <p>한국산업인력공단</p>
          </li>
          <li>
            <h4>OPIc IH (2025.03)</h4>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutMe",
};
</script>
<style scoped>
.about-container {
  padding: 100px 5%;
  text-align: center;
  background-color: var(--bg-secondary-color);
}
h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}
.intro-text {
  font-size: 1.1rem;
  color: var(--text-secondary-color);
  max-width: 700px;
  margin: 0 auto 50px auto;
  line-height: 1.7;
}
.about-grid {
  display: flex;
  justify-content: center;
  gap: 30px;
  text-align: left;
  flex-wrap: wrap;
}
.about-card {
  background: var(--bg-color);
  box-shadow: 0 4px 20px var(--card-shadow-color);
  border-radius: 15px;
  border: 1px solid var(--card-border-color);
  padding: 30px;
  width: 420px;
  transition: all 0.3s ease;
}
.about-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}
.about-card h3 {
  font-size: 1.5rem;
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.about-card ul {
  list-style: none;
  padding: 0;
}
.about-card li {
  margin-bottom: 20px;
}
.about-card h4 {
  font-size: 1.1rem;
  color: var(--text-primary-color);
  margin: 0 0 5px 0;
}
.about-card p {
  font-size: 0.95rem;
  color: var(--text-secondary-color);
  margin: 0;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .about-container {
    padding: 60px 5%;
  }
  .about-card {
    width: 100%;
  }
}
</style>
